/**
 *
 * @author: Huning
 * @date: 2019-07-03
 *
 */
import React, { PureComponent, Fragment } from 'react'
import { matchPath } from 'react-router'
import { Link, withRouter } from 'react-router-dom'
import { Breadcrumb } from 'antd'
import { routerUtil } from '@utils/config'
import routerConfig, { BreadRouter } from '@/routes/routesConfig'

@withRouter
class BasicBread extends PureComponent {
  render() {
    const { location } = this.props
    const { pathname } = location
    const c = routerUtil.searchRouterLinkList(BreadRouter, pathname)
    const BreadcrumbItem = ({ name, path }) => (
      <Breadcrumb.Item key={name}>
        {path && path !== c[c.length - 1].path ? (
          <Link style={{ textDecoration: 'underline' }} to={path}>
            {name}
          </Link>
        ) : (
          <span>{name}</span>
        )}
      </Breadcrumb.Item>
    )
    return <Breadcrumb style={{ margin: '16px 0' }}>{c.map(BreadcrumbItem)}</Breadcrumb>
  }
}

export default BasicBread
